module.exports = __webpack_public_path__ + "static/media/teleMedicineIcon.82639f40.svg";